import React, { useState } from 'react'
import { useTranslation } from '~/hooks/useTranslation'
import { Input } from '~/lib/ui/input'
import { useExercise } from '../ExerciseProvider'
import { TextArea } from './index'
import { RadioGroup, RadioGroupItem } from '~/lib/ui/radio-group'
import { cn } from '~/lib/utils'

const PartOne = () => {
  const [questionClass, setQuestionClass] = useState('opacity-0')
  return (
    <div className="flex flex-col gap-4">
      <QuestionOne setQuestionClass={setQuestionClass} />
      <QuestionTwo questionClass={questionClass} />
      <QuestionThree questionClass={questionClass} />
    </div>
  )
}

export default PartOne

const QuestionOne = ({ setQuestionClass }) => {
  const { getResponse, handleChange } = useExercise()
  const { t } = useTranslation('discovering_your_consulting_niche')
  const skills = t('pages.0.skills', { returnObjects: true })
  const instructions = t('pages.0.instructions')

  const fadeIn = () => {
    setQuestionClass('opacity-100')
  }
  const fadeOut = () => {
    setQuestionClass('opacity-0 ')
  }

  const handleValueChange = (slug) => {
    setResponse(slug)
    handleChange(0, 1, null, slug)
    fadeOut()
    setTimeout(() => {
      fadeIn()
    }, 200)
  }

  const [response, setResponse] = useState(getResponse(0, 1))
  return (
    <div className="flex flex-col gap-4">
      <div className="subtitle">{instructions}</div>
      <RadioGroup
        onValueChange={handleValueChange}
        className="flex flex-col gap-2"
        value={response}
      >
        {skills.map((skill) => (
          <SkillSection
            skill={skill}
            key={`skill-section-${skill.slug}`}
            setResponse={setResponse}
            handleValueChange={handleValueChange}
          />
        ))}
      </RadioGroup>
    </div>
  )
}

const QuestionTwo = ({ questionClass }) => {
  const { t } = useTranslation('discovering_your_consulting_niche')
  const { getResponse, handleChange } = useExercise()
  const slugOptions = ['a', 'b', 'c', 'd', 'e']
  const slug = getResponse(0, 1)
  const slugSection = slugOptions.includes(slug) ? slug : 'f'
  const questionTwo = t(`pages.0.followup.${slugSection}`, {
    returnObjects: true,
  })

  const { question, options } = questionTwo

  const showOptions = slug && slugOptions.includes(slug)
  const showTextArea = slug && !slugOptions.includes(slug)

  const response = getResponse(0, 2)

  const handleValueChange = (option) => {
    handleChange(0, 2, null, option)
  }

  return (
    <div
      className={cn(
        'flex flex-col gap-4 transition-opacity duration-1000',
        questionClass,
      )}
    >
      <div className="subtitle">{question}</div>
      {showTextArea && <TextArea slug={'2-other'} />}
      {showOptions && (
        <RadioGroup onValueChange={handleValueChange} defaultValue={response}>
          {options.map((option, idx) => (
            <RadioItem key={`option-${idx}`} val={option} />
          ))}
        </RadioGroup>
      )}
    </div>
  )
}

const QuestionThree = ({ questionClass }) => {
  const { t } = useTranslation('discovering_your_consulting_niche')
  return (
    <div
      className={cn(
        'flex flex-col gap-4 transition-opacity duration-1000',
        questionClass,
      )}
    >
      <div className="subtitle">{t('pages.0.question_3')}</div>
      <TextArea slug={'3-text'} />
    </div>
  )
}

const SkillSection = ({ skill, setResponse, handleValueChange }) => {
  const { name, slug } = skill
  const { getResponse, handleChange } = useExercise()

  const handleTextChange = (e) => {
    handleChange(0, '1-other', e)
  }

  const response = getResponse(0, 1)

  const otherVal = response === 'f' ? getResponse(0, '1-other') || '' : ''

  const selectF = () => {
    setResponse('f')
    handleValueChange('f')
  }

  return (
    <div className={'flex flex-col gap-4'}>
      <RadioItem val={slug} name={name} />
      {slug === 'f' && (
        <Input value={otherVal} onChange={handleTextChange} onFocus={selectF} />
      )}
    </div>
  )
}

const RadioItem = ({ val, name }) => {
  return (
    <div className="flex items-center gap-2">
      <RadioGroupItem id={val} value={val} />
      <label className="!font-normal" htmlFor={val}>
        {name || val}
      </label>
    </div>
  )
}
